export const helpButtons = [
	{
		text: 'SUPPORT CENTER',
		btn_link: 'https://lendami.com.ph/support-center-help',
		class: 'btn-primary btn-border-none'
	},
	{
		text: 'FAQs',
		btn_link: 'https://lendami.com.ph/faqs/',
		class: 'btn-yellow btn-border-none'
	},
	{
		text: 'CONTACT US',
		btn_link: 'https://lendami.com.ph/contact-us',
		class: 'btn-green btn-border-none'
	}
];
